import { render, staticRenderFns } from "./BulkTransferModal.vue?vue&type=template&id=d9c2984a&"
import script from "./BulkTransferModal.vue?vue&type=script&lang=js&"
export * from "./BulkTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports